import React from 'react';
import '../styles/LoadingMessage.css';

const LoadingMessage = () => {
  return (
    <div className="loading-message">
      <div className="shimmer-line" style={{ width: '80%' }} />
      <div className="shimmer-line" style={{ width: '60%' }} />
      <div className="shimmer-line" style={{ width: '70%' }} />
    </div>
  );
};

export default LoadingMessage;
